export interface ResponsiveTableLabelsHandle {
  disconnect(): void;
  refresh(): void;
}

export function installResponsiveTableLabels(
  root: ParentNode = document,
): ResponsiveTableLabelsHandle {
  const observer = new MutationObserver(() => applyResponsiveTableLabels(root));
  observer.observe(document.body, { childList: true, subtree: true });
  applyResponsiveTableLabels(root);

  return {
    disconnect() {
      observer.disconnect();
    },
    refresh() {
      applyResponsiveTableLabels(root);
    },
  };
}

export function applyResponsiveTableLabels(root: ParentNode = document): void {
  root.querySelectorAll<HTMLTableElement>(".pr-table").forEach(applyLabelsToTable);
}

function applyLabelsToTable(table: HTMLTableElement): void {
  const headers = readTableHeaders(table);
  table
    .querySelectorAll<HTMLTableRowElement>("tbody tr")
    .forEach((row) => applyLabelsToRow(row, headers));
}

function readTableHeaders(table: HTMLTableElement): string[] {
  return Array.from(table.querySelectorAll<HTMLTableCellElement>("thead th")).map((header) =>
    normalizeHeader(header.textContent),
  );
}

function applyLabelsToRow(row: HTMLTableRowElement, headers: string[]): void {
  Array.from(row.children).forEach((cell, index) => {
    if (!(cell instanceof HTMLElement)) return;
    const label = headers[index];
    if (label === undefined || label.length === 0) return;
    cell.dataset["label"] = label;
  });
}

function normalizeHeader(value: string | null): string {
  return value?.replace(/\s+/g, " ").trim() ?? "";
}
